import { render, staticRenderFns } from "./DialogImportExcel.vue?vue&type=template&id=2b589fc1&scoped=true"
import script from "./DialogImportExcel.vue?vue&type=script&lang=js"
export * from "./DialogImportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b589fc1",
  null
  
)

export default component.exports